import { Deserializable } from '../../../protocols/deserializable';
import { HighGuideRecommendationAxis } from './high-guide-recommendation-axis';

/**
 * The structured boost axis a snapshot scored highest on, plus how loudly to say so.
 *
 * Resolved entirely server side, including the tiebreak between two axes that scored identically - the backend is
 * the only place holding the individual signals a tie is broken on. `null` when no axis cleared the bar, which is
 * the common case for a product with few signals.
 */
export class HighGuideLeadingAxis implements Deserializable {
  public axis: HighGuideRecommendationAxis;
  public score: number;

  /**
   * Flame count to render, 0-3. Precomputed from `score` by the backend, so the client must not rederive it - the
   * bucket boundaries are free to change without a client release. A `HighGuideLeadingAxis` is only ever sent when
   * this is greater than 0.
   */
  public flames: number;

  onDeserialize(): void {}
}
